import React from 'react';
import { RouteProp, useRoute } from '@react-navigation/native';
import { CRMParamList } from '../../../typings/Params';
import { RootNavigation } from '../../../Routes';
import MaintenanceRequestComponent from './MaintenanceRequestComponent';

export default function MaintenanceRequestDetail({ navigation }: {
    navigation: RootNavigation;
}) {
    const route = useRoute<RouteProp<CRMParamList, 'MaintenanceRequestDetail'>>();
    return <MaintenanceRequestComponent navigation={navigation} route={route} page={'maintenance-requests'} />;
}
